import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  inject,
} from '@angular/core';
import { randomString } from '../../../lib/random-string';

// Counter that smoothly counts up and down to a given value with a vertical slide animation

@Component({
  selector: 'app-smooth-counter',
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './smooth-counter.component.html',
  styleUrls: ['./smooth-counter.component.scss'],
})
export class SmoothCounterComponent implements OnChanges {
  private check = inject(ChangeDetectorRef);
  @Input() value: number;
  @Input() sizeModifier: number;
  values: { value: number; id: string }[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.value) {
      if (changes.value.firstChange || changes.value.previousValue === undefined) {
        this.values = [{ value: this.value, id: this.value ? this.value.toString() : randomString(10) }];
      } else {
        this.values = this.generateValues(changes.value.currentValue, changes.value.previousValue).map(value => ({
          value,
          id: value ? value.toString() : randomString(10),
        }));

        setTimeout(() => {
          this.values = [{ value: this.value, id: this.value ? this.value.toString() : randomString(10) }];
          this.check.detectChanges();
        }, 500);
      }
    }
  }

  private generateValues(value: number, previousValue: number): number[] {
    if (value > previousValue) return [value, previousValue];
    return [previousValue, value];
  }
}
